import React from "react";
import { ChoiceModel } from "../../models/ChoiceModel";
import { BaseChoice } from "./BaseChoice";
import { QuestionModel } from "../../models/QuestionModel";
import { getSettingString, getSettingBoolean } from "../../models/utilities/settingUtilities";
import { blurFocusedField } from "../../utils";
import { getRendererProps } from "../renderers/BaseRenderer";
import { translate } from "../../models/utilities/translationUtilities";
import ImageChoiceRenderer from "../renderers/v2/ImageChoiceRenderer";

export class ImageSelect extends BaseChoice<{}, {}> {
    min(question: QuestionModel) {
        return getSettingString(question, "MinRequiredAnswers");
    }

    max(question: QuestionModel) {
        return getSettingString(question, "MaxAllowedAnswers");
    }

    getChoiceLabel(choice: ChoiceModel) {
        return translate(choice, "TEXT", this.props.language);
    }

    onChoiceSelected = () => {
        blurFocusedField();
        if (this.props.isDisabled) return;
        this.setMentions(this.props.variable.name, (mentions) => {
            const isSelectedExclusive =
                getSettingBoolean(this.props.choice, "Exclusive") ||
                this.max(this.props.question) === "1";
            if (this.props.variable.choiceList !== undefined) {
                for (const c of this.props.variable.choiceList) {
                    if (c.index === this.props.choice.index) continue;
                    if (isSelectedExclusive || getSettingBoolean(c, "Exclusive"))
                        mentions = mentions.removeValue(c.value);
                }
            }
            return mentions.toggle(this.props.choice.value, this.props.openEnd);
        });
    };

    renderChoice(choice: ChoiceModel) {
        return (
            <ImageChoiceRenderer
                {...getRendererProps(this.props)}
                selected={this.props.isSelected}
                gridRendering={this.props.gridRendering}
                onSelect={this.onChoiceSelected}
                choice={choice}
                disabled={this.props.isDisabled}
            />
        );
    }
}
